import styled from '@emotion/styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 900px;
`;

export const CenteredH2 = styled.h2`
  text-align: center;
`;

export const ModalField = styled.div`
  width: 100%;
  margin-bottom: 10px;

  input {
    width: 100%;
  }
`;

export const LinkTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LinkTypeOption = styled.div`
  display: flex;

  label {
    white-space: nowrap;
    margin-left: 4px;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

export const ColorOption = styled.div<{ selected: boolean }>`
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 5px;
  cursor: pointer;
  background-color: ${(props) => props.color};
  border: ${(props) => (props.selected ? '3px solid black' : '1px solid #000')};
  transition: border 0.2s ease-in-out;
`;

export const DocumentInput = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const GeneralDocumentPickerContainer = styled.div`
  padding: 4px;
  width: 100%;
`;

export const AssignmentTypeSelectContainer = styled.div`
  width: 100%;
  max-width: 150px;
`;

export const AssignmentSelectContainer = styled.div`
  width: 100%;
  margin-top: 10px;
`;
